// ANCHOR Base
import { Plus } from 'baseui/icon';
import { Block } from 'baseui/block';
import { Button, KIND } from 'baseui/button';

// ANCHOR Models
import { useCreateFormQuestionModalVisibilityShow } from '@lyon/scoped-models/form/create/CreateFormQuestionModalVisibility';
import { useFormQuestionsData } from '@lyon/scoped-models/form/FormQuestionsData';
import { useFormDataID } from '@lyon/scoped-models/form/FormData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Constants
import { LyonCreateFormQuestion } from '@lyon/components/forms/LyonCreateFormQuestion';
import { LABEL } from './constants';

// ANCHOR Styles
import { BLOCK, BUTTON } from './styles';

export const LyonUpdateFormOutlineTabAddQuestion = constant(() => {
  const show = useCreateFormQuestionModalVisibilityShow();
  const formId = useFormDataID();
  const questionLength = useFormQuestionsData()?.length;

  if (!formId || typeof questionLength === 'undefined') {
    return null;
  }

  return (
    <Block overrides={BLOCK}>
      <Button
        type="button"
        kind={KIND.primary}
        onClick={show}
        startEnhancer={Plus}
        overrides={BUTTON}
      >
        {LABEL}
      </Button>
      <LyonCreateFormQuestion formId={formId} length={questionLength} />
    </Block>
  );
});
